import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ActivitiesSection } from './components/ActivitiesSection';
import { HealthSection } from './components/HealthSection';
import { DirectorsSection } from './components/DirectorsSection';
import { FacilitySection } from './components/FacilitySection';
import { SocialSection } from './components/SocialSection';
import { LocationSection } from './components/LocationSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-kiron-black text-white font-inter selection:bg-kiron-teal selection:text-kiron-black" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ActivitiesSection data-id="element-5" />
        <HealthSection data-id="element-6" />
        <DirectorsSection data-id="element-7" />
        <FacilitySection data-id="element-8" />
        <SocialSection data-id="element-9" />
        <LocationSection data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}